/**
 * List Schema of OcorrenciaTracking
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {OcorrenciaTracking} from '@/model/resource/OcorrenciaTracking'

/* TODO: review generated schema */
export class ListOcorrenciaTrackingSchema extends Schema {
  readonly name = 'ListOcorrenciaTracking'

  readonly fieldSet: FieldSet<OcorrenciaTracking> = {
    idOcorrenciaTracking: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    tipoOcorrencia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.tipoOcorrencia?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    dataOcorrencia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataOcorrencia),
      },
    }),
    descricao: (): FieldComponent => ({
      is: Component.Render,
    }),
    idOcorrenciaExterna: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
